import { handleComponentError } from "../decorators/handleComponentError"

export class PageTitle {
    private pageTitle?: string

    constructor(pageTitle?: string) {
        this.pageTitle = pageTitle
    }

    private setPageTitle(pageTitle?: string) {
        if (pageTitle) {
            const titleTag = document.getElementsByTagName("title")[0]
            titleTag.textContent = pageTitle
        }
    }
    @handleComponentError("PageTitle")
    render() {
        this.setPageTitle(this.pageTitle)
    }
}
